import { useState, type ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

interface LegalPreviewProps {
  readonly pageType: "privacy" | "terms" | "accessibility";
  readonly tenantSlug: string;
}

export function LegalPreview({
  pageType,
  tenantSlug,
}: LegalPreviewProps): ReactNode {
  const [mobileView, setMobileView] = useState(false);

  const src = `/api/legal/page/${pageType}`;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <Button
          variant={mobileView ? "outline" : "default"}
          size="sm"
          onClick={() => setMobileView(false)}
          className="min-h-[44px]"
        >
          {"מחשב"}
        </Button>
        <Button
          variant={mobileView ? "default" : "outline"}
          size="sm"
          onClick={() => setMobileView(true)}
          className="min-h-[44px]"
        >
          {"נייד"}
        </Button>
      </div>

      <div
        className={cn(
          "overflow-hidden rounded-lg border bg-white",
          mobileView ? "mx-auto w-[360px]" : "w-full",
        )}
      >
        <iframe
          src={src}
          title={`תצוגה מקדימה — ${pageType}`}
          className="h-[600px] w-full border-0"
          sandbox="allow-same-origin"
        />
      </div>
    </div>
  );
}
